import React from 'react';
import { Form } from 'formsy-semantic-ui-react';
import { connect } from 'react-redux';
import { Grid, Button, Card, Loader, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import LoadingComponent from "../../common/LoadingComponent";
import './styles.css';

import { singleLineText } from './../../common/RegexValidation';
import setColor from './../../common/SetColor'
import ImageResizer from './../../drive/ImageResizer/ImageResizer';

class UserDetails extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      updatedImage: props.user.profilePic
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.cancelUserDetails = this.cancelUserDetails.bind(this);
  }

  cancelUserDetails() {
    dispatch.profile.modalOpen(false);
    dispatch.users.setProfileImage(null);
  }

  openImageModal = (open) => {
    this.setState({ open: open })
  }

  cloudinaryImage = (imageData) => {
    this.setState({ loader: true })
    if (imageData && imageData.data) {
      this.setState({ updatedImage: imageData.data.secure_url, loader: false })
      dispatch.lifeCycle.setCardImageAsync(imageData.data);
    }
  }

  async onSubmit(formdata) {

    var payload = {
      id: this.props.user._id,
      firstName: formdata.firstName,
      lastName: formdata.lastName,

    };
    if (this.props.imageProfileObjectCloudinary) {
      payload.profilePic = this.state.updatedImage;
    }
    dispatch.profile.changeUserName(payload);
    let userid = this.props.user._id.toString();
    let payloadObj = {};
    payloadObj.organizationId = this.props.selectedOrganisation.id;
    payloadObj.userid = userid;

    if (payloadObj.organizationId && this.props.currentContext === "content") {
      await dispatch.content.getAllContents(payloadObj);
    }

    if (this.props.orgUniqueId) {
      await dispatch.organizationTab.getUsersTreeAsync({ id: this.props.orgUniqueId, accountId: this.props.selectedAccount._id });
    }

  }


  render() {
    let firstName = this.props.user.firstName;
    let lastName = this.props.user.lastName;
    let email = this.props.user.email;
    const errorLabel = <div className="customErrorLabel" />;


    return (
      <Grid>
        <Grid.Column width={6}>

          <Card className="userProfilePic" >
            <Card.Content >
              <div >
                {this.state.loader ? <Loader active /> : null}
                {this.state.updatedImage ?
                  <img src={this.state.updatedImage} className="fitImage" alt="User Profile Pic" /> :
                  this.props.user.firstName && this.props.user.lastName ?
                    <span className="avaterNameUpdate" style={{ background: setColor(this.props.user.firstName.charAt(0).toUpperCase()) }}>
                      {this.props.user.firstName.charAt(0).toUpperCase()}
                      {this.props.user.lastName.charAt(0).toUpperCase()}
                    </span>
                    : <span className="avaterNameUpdate"> <Icon name="user" /></span>
                }

                <Button className="circular_24_icon circle-image" icon='pencil' type="file" onClick={() => this.openImageModal(true)} />
              </div >
            </Card.Content>
          </Card>
          <ImageResizer
            image={this.state.updatedImage}
            openImageModal={this.openImageModal}
            cloudinaryImage={this.cloudinaryImage}
            open={this.state.open}
            envData={this.props.envData}
            width={120}
            height={120}
            borderRadius={500}
          />


        </Grid.Column>
        <Grid.Column width={10}>
          <LoadingComponent active={this.props.changeUserNameFunc} message="Loading..." />
          <Form noValidate
            ref={ref => this.form = ref}
            onValidSubmit={this.onSubmit}
            id="profUserDetails">
            <Form.Input
              defaultValue={firstName}
              name="firstName"
              label="First Name"
              placeholder="First Name"
              id="firstName"
              required
              errorLabel={errorLabel}
              validations={{ matchRegexp: singleLineText }}
              validationErrors={{
                matchRegexp: 'Max limit is 128.No numbers or special characters allowed. No space allowed in starting.',
                isDefaultRequiredValue: 'First name is required',
              }}
              instantValidation
              autoFocus
            />
            <Form.Input
              defaultValue={lastName}
              name="lastName"
              label="Last Name"
              placeholder="Last Name"
              id="lastName"
              required
              errorLabel={errorLabel}
              validations={{ matchRegexp: singleLineText }}
              validationErrors={{
                matchRegexp: 'Max limit is 128.No numbers or special characters allowed. No space allowed in starting.',
                isDefaultRequiredValue: 'Last Name is required',
              }}
              instantValidation
            />
            <Form.Input
              defaultValue={email}
              name="email"
              label="Email"
              placeholder="Email"
              id="emailAddress"
              disabled
            />
            <span className="actionInFormcy border-none">
              <Button
                disabled={this.props.loaderStatus || this.state.loader}
                type="submit"
                id="submit"
                className="button-submit float-right mar_0">Save</Button>
              <Button id="cancel"
                className="button-cancel float-right"
                onClick={this.cancelUserDetails}
                type="button">Cancel</Button>
            </span>
          </Form>
        </Grid.Column>
      </Grid>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.app.user,
    currentContext: state.app.currentContext,
    selectedOrganisation: state.app.selectedOrganisation,
    profile: state.profile,
    changeUserNameFunc: state.loading.effects.profile.changeUserName,
    imageProfileObjectCloudinary: state.users.imageProfileObjectCloudinary,
    loaderStatus: state.users.loaderBar,
    selectedAccount: state.app.selectedAccount,
    envData: state.app.envData
  };
}

const connectedUserDetails = connect(mapStateToProps)(UserDetails);
export { connectedUserDetails as UserDetails }; 
